module.exports = __webpack_public_path__ + "img/q4.a37744f9.png";